import { ErrorWithResourceKey } from '../../shared/errorWithResourceKey';

export class ObjectNotFoundError extends ErrorWithResourceKey {
    constructor() {
        super('ObjectNotFoundError', undefined, 'errors.object-not-found');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/database/objectNotFoundError.ts